exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stamenmaps-plugin-content th{padding:10px 0}.stamenmaps-plugin-content tr:first-child th{color:#f8971d;font-size:1.2em}@media screen and (max-width:655px){.stamenmaps-plugin-content td,.stamenmaps-plugin-content th{font-size:.7em}.stamenmaps-plugin-content tr td:first-child,.stamenmaps-plugin-content tr th:first-child{width:80px!important}}@media screen and (max-width:500px){.stamenmaps-plugin-content tr:nth-child(2) th{font-size:.5em}}.stamenmaps-plugin-content td{text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./styles/app.css
// module id = 452
// module chunks = 0